import { topics } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            全网热议的话题标签，点击探索你感兴趣的瓜
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-200/70 text-foreground-600 hover:bg-background-300'
              }`}
            >
              <span className="font-medium">{t.tag}</span>
              <span className="text-xs opacity-70">{t.count}</span>
              {t.hot && (
                <span className="inline-block px-1.5 py-0.5 bg-primary-500 text-background-50 text-[10px] rounded-full leading-none">
                  热
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}